import React from 'react';

function Terms() {

  return (
    <div className="content">
      <h2>Terms &amp; Conditions</h2> 
      <p>
                  By downloading or using the app, these terms will
                  automatically apply to you – you should make sure therefore
                  that you read them carefully before using the app. You’re not
                  allowed to copy, or modify the app, any part of the app, or
                  our trademarks in any way. You’re not allowed to attempt to
                  extract the source code of the app, and you also shouldn’t try
                  to translate the app into other languages, or make derivative
                  versions. The app itself, and all the trade marks, copyright,
                  database rights and other intellectual property rights related
                  to it, still belong to Swaphead.
                </p> <p>
                  Swaphead (hereinafter referred to as “the application”, “our”, “we” or “us”)  is committed to be
                  as useful and efficient as possible. For that reason, we
                  reserve the right to make changes to the app or to charge for
                  its services, at any time and for any reason. We will never
                  charge you for the app or its services without making it very
                  clear to you exactly what you’re paying for.
                </p> 
                <h3>Description of Services and Fees</h3>
                <p>
                Swaphead is a mobile application that allows you to create your own videos. It enables you to choose
                a video from various categories and swipe faces in the video with other faces you want. You can create
                special content in several subjects such as birthday, anniversary, baby shower, love message or
                wedding proposal and you can surprise your beloved ones. Swaphead lets you create single or group
                videos and share them on social media channels.
                </p>
                <p>
                We wish you to be completely satisfied with our services. Malfunctions may be encountered from time
                to time. We solve 99% of the problems that our users encountered by making maintenance and by other
                actions taken by us to provide you an issueless use of our services. 
                </p>

                <h3>Termination</h3>
                <p>
                The license for use of the Services provided herein is effective until terminated. You may terminate your
                license at any time by removing the mobile application from your devices. We reserve the right, without
                notice and in our sole discretion, to terminate your license to access or use our Services according to
                your failure to comply with any of the Terms. We are not responsible for any loss or harm related to
                your inability to access or use our Services.
                </p>

                <h3>Eligibility</h3>
                <p>
                If you are a parent or legal
                guardian of a user under the age of 4 (or the age of legal majority), you agree to be fully responsible for
                the acts or omissions of such user in connection with our Services. If you are accessing or using our
                Services on behalf of another person or entity, you represent that you are authorized to accept these
                Terms on that person or entity’s behalf and that the person or entity agrees to be responsible to us if
                you or the other person or entity violates these Terms.
                </p>

                <h3>Access</h3>
                <p>
                Our mobile Application with the standard functionality is currently made available free of charge. We do not
                guarantee that our Services will always be available or be uninterrupted. You are responsible for making all
                arrangements necessary for you to have access to our Services.
                </p>
                <p>
                We do not represent that our Services will be available in other locations. We may limit the availability of
                our Services or specific functionality to any user or geographic area at any time. If you choose to access
                our Services from a prohibited jurisdiction, it is at your own risk.
                </p>

                <h3>Updates and Support</h3>
                <p>
                We reserve the right to add or remove features or functionality to the application. When your mobile
                phone is set up, the application periodically communicates with our servers. When we release a new
                version of the Application or if we add new features to it, we may ask you to update the application on
                your mobile phone. Before you begin to use updated versions of the Application, you may be asked to
                review and may need to accept the updated Terms of Service. Continuing to use the Services after the
                update proves that the User has agreed and accepted the updated Terms. We may
                  also wish to stop providing the app, and may terminate use of
                  it at any time without giving notice of termination to you.
                  Unless we tell you otherwise, upon any termination, (a) the
                  rights and licenses granted to you in these terms will end;
                  (b) you must stop using the app, and (if needed) delete it
                  from your device.
                </p>

                <p>
                  The Swaphead app stores and processes personal data that
                  you have provided to us, in order to provide our
                  Service. It’s your responsibility to keep your phone and
                  access to the app secure. We therefore recommend that you do
                  not jailbreak or root your phone, which is the process of
                  removing software restrictions and limitations imposed by the
                  official operating system of your device. It could make your
                  phone vulnerable to malware/viruses/malicious programs,
                  compromise your phone’s security features and it could mean
                  that the Swaphead app won’t work properly or at all.
                </p>

                <h3>Privacy</h3>
                <p>
                Please find our Privacy Policy for detailed information about how we collect, use and disclose the
                information given by you. Transfer and storage of information about you is governed by our Privacy
                Policy aswell. 
                </p>
                <p>
                Data security is provided by the Application. However, the user is responsible for any unauthorized
                access to user information, contact information and other contents; abusing, storage, reproduction, sale,
                copying, as well as illegal use of user information, contact information and other content.
                </p>

                <h3>Code of Conduct and Prohibited Content</h3>
                <p>
                You will not violate any applicable law, contract, intellectual property or other third-party right or commit
                a tort, and you are solely responsible for your conduct while accessing or using our Services. You will
                not:
                </p>

                <ul>
                  <li>Engage in any harassing, threatening, intimidating, predatory or stalking conduct;</li>
                  <li>Use or attempt to use another user’s account without authorization from that user and Swaphead</li>
                  <li>Create a false identity or otherwise misrepresents your or another true identity;</li>
                  <li>Use our Services in any manner that could interfere with, disrupt, negatively affect or inhibit
                    other users from fully enjoying our Services or that could damage, disable, overburden or impair
                    the functioning of our Services in any manner;</li>
                  <li>Reverse engineer any aspect of our Services or do anything that might discover source code or
bypass or circumvent measures employed to prevent or limit access to any part of our Services;</li>
                  <li>Attempt to circumvent any content-filtering techniques we employ or attempt to access any
feature or area of our Services that you are not authorized to access;</li>
                  <li>
                  Develop or use any third-party applications that interact with our Services without our prior
written consent, including any scripts designed to scrape or extract data from our Services;
                  </li>
                  <li>
                  Use our Services for any illegal or unauthorized purpose, or engage in, encourage or promote
any activity that violates these Terms.
                  </li>
                  <li>
                  Engage in any action that directly or indirectly interferes with the integrity of our Services, including
but not limited to any attempts to access or hack our servers or network.
                  </li>
                </ul>

                <p>You may, also, not create, post, store or share any User Content that:</p>
                <ul>
                  <li>Is unlawful, libelous, defamatory, obscene, pornographic, indecent, suggestive, harassing,
threatening, invasive of privacy or publicity rights, abusive, inflammatory or fraudulent;</li>
                  <li>
                  Would constitute, encourage or provide instructions for a criminal offense, violate the rights of
any party or otherwise create liability or violate any local, state, national or international law
                  </li>
                  <li>
                  May infringe any patent, trademark, trade secret, copyright or other intellectual or proprietary
right of any party;
                  </li>
                  <li>
                  Contains or depicts any statements, remarks or claims that do not reflect your honest views
and experiences;
                  </li>
                  <li>
                  Impersonates, or misrepresents your affiliation with, any person or entity;
                  </li>
                  <li>
                  Contains any unsolicited promotions, political campaigning, advertising or solicitations;
                  </li>
                  <li>
                  Contains any private or personal information of a third party without such third party’s consent;
                  </li>
                  <li>
                  Contains any viruses, corrupted data or other harmful, disruptive or destructive files or
content; or
                  </li>
                  <li>
                  Is, in our sole judgment, objectionable or that restricts or inhibits any other person from using
or enjoying our Services, or that may expose Swaphead or others to any harm or liability of
any type.
                  </li>
                </ul>
                <p>In addition, although we have no obligation to screen, edit or monitor User Content, we may delete or
remove User Content at any time and for any reason.</p>
                <p>
                Please note that you are not given the permission to use the name, logo or other commercial symbols
of the Application. Please read our “Intellectual Property” section for detailed information. 
                </p>
                <p>
                Any violation of this section may cause you to be a subject to legal and/ or criminal penalties.
                </p>

                <h3>Indemnification</h3>
                <p>You agree to indemnify, defend and hold harmless Swaphead and each of out respective officers,
directors, agents, partners and employees (collectively, the "Swaphead" Parties”) from and aganist any
loss, liability, claim, demand, damages, expenses or costs arising out of or related to your actions listed
below:</p>
                <ul>
                  <li>Your failure to comply with our Terms, including, without limitation, that anything you submit or
contribute violate the rights of any third party or applicable laws;</li>
                  <li>
                  Any use or content you submit via our Services;
                  </li>
                  <li>
                  Any activity in which you engage on or through the Services 
                  </li>
                  <li>
                  Any misrepresentation made by you.
                  </li>
                  <li>
                  Your violation, misappropriation or infringement of any rights of another (including intellectual
property rights or privacy rights)
                  </li>
                </ul>

                <p>
                You agree to promptly notify Swaphead of any third party Claims, cooperate with Swaphead in defending
such Claims and pay all fees, costs and expenses associated with defending such Claims (including,
but not limited to, attorneys’ fees).
                </p>

                <h3>Abuse of Swaphead Services</h3>
                <p>
                Swaphead reserves the right to investigate suspected violations of our Terms, of Service herein and may
seek to gather information from the user who is suspected of violation, and from any other user. We will
collect and use such information in accordance with our Privacy Policy.
                </p>
                <p>
                In its sole discretion, Swaphead may restrict, suspend or terminate the account of any User who abuses or
misuses the Services. By accepting our Terms of Service herein, you waive and hold harmless Swaphead
and Swaphead parties from any claims arising out of the action taken by Swaphead according to such
misuse of the Services by either Swaphead or law enforcement authorities. 
                </p>

                <h3>Copyright and Trademark Complaints</h3>
                <p>
                If you believe that anything on our Services infringes any copyright that you own or control, you may
notify Swaphead through: Email Address - swapheadd@gmail.com
                </p>

                <p><strong>The notification must include the following:</strong></p>
                <ul>
                  <li>physical address, email and phone number, so that we can contact you.</li>
                  <li>Complete description of your work that you believe has been infringed.</li>
                  <li>Identifying location of the allegedly infringing work.</li>
                  <li>A statement that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or law.</li>
                  <li>A statement, made under penalty of perjury, that the above information is accurate, and that you are the copyright owner or are authorized to act on behalf of the copyright owner.</li>
                  <li>The physical or electronic signature of the copyright owner or an authorized representative of the copyright owner. To satisfy this requirement, you may type your full legal name (not that of a company) at the bottom of your notification.</li>
                </ul>

                <h3>Disclaimer of Warranties</h3>
                <p>The Site and Services are provided on an as-is and as-available basis. You agree that your use of the Site and/or Services will be at your
                   sole risk except as expressly set out in these Terms and Conditions. All warranties, terms, conditions and undertakings, express or implied 
                   (including by statute, custom or usage, a course of dealing, or common law) in connection with the Site and Services and your use thereof 
                   including, without limitation, the implied warranties of satisfactory quality, fitness for a particular purpose and non-infringement are 
                   excluded to the fullest extent permitted by applicable law.  </p>
                <p>
                  We make no warranties or representations about the accuracy or completeness of the Site’s content and are not liable for any 
                  (1) errors or omissions in content: (2) any unauthorized access to or use of our servers and/or any and all personal information and/or 
                  financial information stored on our server; (3) any interruption or cessation of transmission to or from the site or services; and/or 
                  (4) any bugs, viruses, trojan horses, or the like which may be transmitted to or through the site by any third party. We will not be 
                  responsible for any delay or failure to comply with our obligations under these Terms and Conditions if such delay or failure is 
                  caused by an event beyond our reasonable control. 
                </p>

                <p>All information on the Site/App is provided in good faith, however we make no representation or warranty of any kind, express or implied, 
                  regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information on the Site/App.</p>

                <p>
                YOUR USE OF OUR SERVİCES IS AT YOUR SOLE RISK. OUR SERVICES ARE PROVIDED “AS IS”
                WITHOUT ANY WARRANTIES, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED
                TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                TITLE, AND NON-INFRINGEMENT. WHILE SWAPHEAD ATTEMPTS TO MAKE YOUR ACCESS TO
                AND USE OF OUR SERVICES SAFE, WE CANNOT WARRANT THAT THE SERVICES PROVIDED
                ARE ACCURATE, RELIABLE, ERROR-FREE, UNITERRUPTED; THE APPLICATION OR SERVICES
                OR THE SERVERS ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. 
                </p>
                <p>
                THE APPLICATION MAKES NO REPRESENTATIONS OR WARRANTIES REGARDING ITS USERS'
                BEHAVIORS; THE USER SHALL INDIVIDUALLY AND SOLELY BE RESPONSIBLE FOR HIS/HER
                ACTIONS AND INTERACTION WITH OTHER USERS.
                </p>

                <h3>Limitation of Liability</h3>
                <p>
                SWAPHEAD AND THE OTHER SWAPHEAD PARTIES WILL NOT BE LIABLE TO YOU UNDER ANY
                THEORY OF LIABILITY—WHETHER BASED IN CONTRACT, TORT, NEGLIGENCE, STRICT
                LIABILITY, WARRANTY, OR OTHERWISE—FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY,
                INCIDENTAL, PUNITIVE OR SPECIAL DAMAGES OR LOST PROFITS, EVEN IF SWAPHEAD OR
                THE OTHER SWAPHEAD PARTIES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH
                DAMAGES.
                </p>
                <p>
                WE WILL NOT BE LIABLE TO ANY USER FOR ANY LOSS OR DAMAGE, WHETHER IN CONTRACT,
                TORT (INCLUDING NEGLIGENCE), BREACH OF STATUTORY DUTY, OR OTHERWISE, EVEN IF
                FORESEEABLE, ARISING UNDER OR IN CONNECTION WITH USE OF, OR INABILITY TO USE THE
                SWAPHEAD SERVICES.
                </p>
                <p>
                THE LIMITATIONS SET FORTH IN THIS SECTION WILL NOT LIMIT OR EXCLUDE LIABİLITY FOR
                THE GROSS NEGLIGENCE, FRAUD OR INTENTIONAL MISCONDUCT OF SWAPHEAD OR THE
                OTHER SWAPHEAD PARTIES OR FOR ANY OTHER MATTERS IN WHICH LIABILITY CANNOT BE
                EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
                </p>

              <h3>Third Party Contents</h3>
                 <div><p>
                    The app does use third party services that declare their own
                    Terms and Conditions.
                  </p> <p>
                    Link to Terms and Conditions of third party service
                    providers used by the app
                  </p> <ul>
                  <li><a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Google Play Services</a></li><li><a href="https://developers.google.com/admob/terms" target="_blank" rel="noopener noreferrer">AdMob</a></li><li><a href="https://firebase.google.com/terms/analytics" target="_blank" rel="noopener noreferrer">Google Analytics for Firebase</a></li><li><a href="https://firebase.google.com/terms/crashlytics" target="_blank" rel="noopener noreferrer">Firebase Crashlytics</a></li>
                    </ul></div> <p>
                  You should be aware that there are certain things that
                  Swaphead will not take responsibility for. Certain
                  functions of the app will require the app to have an active
                  internet connection. The connection can be Wi-Fi, or provided
                  by your mobile network provider, but Swaphead
                  cannot take responsibility for the app not working at full
                  functionality if you don’t have access to Wi-Fi, and you don’t
                  have any of your data allowance left.
                </p> <p></p> <p>
                  If you’re using the app outside of an area with Wi-Fi, you
                  should remember that your terms of the agreement with your
                  mobile network provider will still apply. As a result, you may
                  be charged by your mobile provider for the cost of data for
                  the duration of the connection while accessing the app, or
                  other third party charges. In using the app, you’re accepting
                  responsibility for any such charges, including roaming data
                  charges if you use the app outside of your home territory
                  (i.e. region or country) without turning off data roaming. If
                  you are not the bill payer for the device on which you’re
                  using the app, please be aware that we assume that you have
                  received permission from the bill payer for using the app.
                </p> <p>
                  Along the same lines, Swaphead cannot always take
                  responsibility for the way you use the app i.e. You need to
                  make sure that your device stays charged – if it runs out of
                  battery and you can’t turn it on to avail the Service,
                  Swaphead cannot accept responsibility.
                </p> <p>
                  With respect to Swaphead’s responsibility for your
                  use of the app, when you’re using the app, it’s important to
                  bear in mind that although we endeavour to ensure that it is
                  updated and correct at all times, we do rely on third parties
                  to provide information to us so that we can make it available
                  to you. Swaphead accepts no liability for any
                  loss, direct or indirect, you experience as a result of
                  relying wholly on this functionality of the app.
                </p> 
                
                <p><strong>Changes to This Terms and Conditions</strong></p> <p>
                  We may update our Terms and Conditions
                  from time to time. Thus, you are advised to review this page
                  periodically for any changes. We will
                  notify you of any changes by posting the new Terms and
                  Conditions on this page.
                </p> <p>
                  These terms and conditions are effective as of Aug 8th, 2020
                </p> <p><strong>Contact Us</strong></p> <p>
                  If you have any questions or suggestions about our
                  Terms and Conditions, do not hesitate to contact us
                  at swapheadd@gmail.com.
                </p> 
    </div>
  );
}

export default Terms;